import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./component/HomePage";
import BackButton from "./component/BackButton";
import MasterPage from "./Master/MasterPage";
import DepartmentList from "./Master/DepartmentList";
import DepartmentMaster from "./Master/DepartmentMaster";
import DesignationMaster from "./Master/DesignationMaster";
import DesignationList from "./Master/DesignationList";
import LeaveTypeMaster from "./Master/leavetypemaster";
import LeaveTypeList from "./Master/leavetypelist";
import HolidayMaster from "./Master/HolidayMaster";
import HolidayList from "./Master/HolidayList";
import ShiftMaster from "./Master/Shiftmaster";
import ShiftList from "./Master/Shiftlist";
import PolicyMaster from "./Master/Policymaster";
import PolicyList from "./Master/PolicyList";
import LocationMaster from "./Master/LocationMaster";
import LocationList from "./Master/Locationlist";
import PayrollComponentMaster from "./Master/PayrollComponentMaster";
import PayrollComponentList from "./Master/PayrollComponentList";
import EmployeeMaster from "./Master/EmployeeMaster";
import EmployeeList from "./Master/EmployeeList";
import LeaveDashboard from "./Master/LeaveDashboard";
import Dashboard from "./component/Dashboard";
import AdminLogin from "./component/AdminLogin";
import EditProfile from "./component/EditProfile";
import ChangePassword from "./component/ChangePassword";
import AdminManagement from "./component/AdminManagement";
import toast, { Toaster } from "react-hot-toast";
import LeaveRuleMaster from "./Master/LeaveRuleMaster";
import LeaveRuleList from "./Master/LeaveRuleList";
import LeaveAllocationForm from "./Master/LeaveAllocationForm";
import LeaveAllocationList from "./Master/LeaveAllocationList";
import EmployeeDashboard from "./EmployeeCorner/EmployeeDashboard";
import UserProfile from "./EmployeeCorner/UserProfile";
import EmployeeHome from "./EmployeeCorner/EmployeeHome";
import EmployeeCornerSidebar from "./EmployeeCorner/EmployeeCornerSidebar";
import EmployeeUserIdCreated from "./EmployeeCorner/EmployeeUserIdCreated";
import EmployeeCalendar from "./EmployeeCorner/EmployeeCalendar";
import EmployeeLeaveApplication from "./EmployeeCorner/EmployeeLeaveApplication";
import SalaryHeadForm from "./Master/SalaryHeadForm";
import SalarySlipHeadList from "./Master/SalarySlipHeadList";
import PaySlipGenerateEmployeeList from "./Master/PaySlipGenerateEmployeeList";
import GeneratePaySlip from "./Master/GeneratePaySlip";
import PaySlipHistory from "./Master/PaySlipHistory";
import ReminderPage from "./Master/ReminderPage";
import ShiftManagement from "./Master/ShiftManagement";
import EmployeeLeaveDetails from "./EmployeeCorner/EmployeeLeaveDetails";
import EmployeeAttendance from "./EmployeeCorner/EmployeeAttendance";
import LeaveHistory from "./Master/LeaveHistory";
import EmployeeAttendanceHistory from "./Master/EmployeeAttendanceHistory";
import AttendanceRegisterHistory from "./Master/AttendanceRegisterHistory";
import DutyRoasterHistory from "./Master/DutyRoasterHistory";
import EmployeePayslipView from "./EmployeeCorner/EmployeePayslipView";
import AttendanceSignIn from "./component/AttendanceSignIn";
import OtRateMaster from "./Master/OtRateMaster";
import OTRateList from "./Master/OTRateList";
import GenerateAllEmployeePayslip from "./Master/GenerateAllEmployeePayslip";
import QualificationMaster from "./Master/QualificationMaster";
import QualificationList from "./Master/QualificationList";
import ProtectedRoute from "./component/ProtectedRoute";
import EmployeeShiftTime from "./EmployeeCorner/EmployeeShiftTime";
import DepartmrentHead from "./Master/DepartmrentHead";
import ActivityHistory from "./Master/ActivityHistory";

const getToastMessageText = (message) => {
  if (typeof message === "string") return message.trim();
  if (message instanceof Error) return message.message || "Error";
  if (message && typeof message === "object") {
    if (typeof message.message === "string") return message.message.trim();
    return "Something went wrong";
  }
  return String(message || "Error");
};

if (!toast.__errorDedupePatched) {
  const originalError = toast.error.bind(toast);
  toast.error = (message, options = {}) => {
    const normalizedMessage = getToastMessageText(message);
    const providedId = options && typeof options === "object" ? options.id : undefined;
    const dedupeId = providedId || `error:${normalizedMessage.toLowerCase()}`;
    return originalError(normalizedMessage, { ...options, id: dedupeId });
  };
  toast.__errorDedupePatched = true;
}

export default function App(){
  return (
    <>
    <Routes>
      <Route path="/" element={<AdminLogin/>} />
      <Route element={<ProtectedRoute/>}>
        <Route path="/Homepage" element={<HomePage/>} />
        <Route path="/BackButton" element={<BackButton/>} />
        <Route path="/MasterPage" element={<MasterPage/>} />
        <Route path="/DepartmentList" element={<DepartmentList/>} />
        <Route path="/DepartmentMaster" element={<DepartmentMaster/>} />
        <Route path="/DesignationMaster" element={<DesignationMaster/>} />
        <Route path="/DesignationList" element={<DesignationList/>} />
        <Route path="/LeaveTypeMaster" element={<LeaveTypeMaster/>} />
        <Route path="/LeaveTypeList" element={<LeaveTypeList/>} />
        <Route path="/HolidayMaster" element={<HolidayMaster/>} />
        <Route path="/HolidayList" element={<HolidayList/>} />
        <Route path="/ShiftMaster" element={<ShiftMaster/>} />
        <Route path="/ShiftList" element={<ShiftList/>} />
        <Route path="/PolicyMaster" element={<PolicyMaster/>} />
        <Route path="/PolicyList" element={<PolicyList/>} />
        <Route path="/LocationMaster" element={<LocationMaster/>} />
        <Route path="/LocationList" element={<LocationList/>} />
        <Route path="/PayrollComponentMaster" element={<PayrollComponentMaster/>} />
        <Route path="/PayrollComponentList" element={<PayrollComponentList/>} />
        <Route path="/EmployeeMaster" element={<EmployeeMaster/>} />
        <Route path="/EmployeeList" element={<EmployeeList/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/EditProfile" element={<EditProfile/>} />
        <Route path="/ChangePassword" element={<ChangePassword/>} />
        <Route path="/AdminManagement" element={<AdminManagement/>} />
        <Route path="/LeaveDashboard" element={<LeaveDashboard/>} />
        <Route path="/LeaveRuleMaster" element={<LeaveRuleMaster/>} />
        <Route path="/LeaveRuleList" element={<LeaveRuleList/>} />
        <Route path="/LeaveAllocationForm" element={<LeaveAllocationForm/>} />
        <Route path="/LeaveAllocationList" element={<LeaveAllocationList/>} />
        <Route path="/EmployeeDashboard" element={<EmployeeDashboard/>} />
        <Route path="/UserProfile" element={<UserProfile/>} />
        <Route path="/EmployeeHome" element={<EmployeeHome/>} />
        <Route path="/EmployeeCornerSidebar" element={<EmployeeCornerSidebar/>} />
        <Route path="/EmployeeUserIdCreated" element={<EmployeeUserIdCreated/>} />
        <Route path="/EmployeeCalendar" element={<EmployeeCalendar/>} />
        <Route path="/EmployeeLeaveApplication" element={<EmployeeLeaveApplication/>} />
        <Route path="/SalaryHeadForm" element={<SalaryHeadForm/>} />
        <Route path="/SalarySlipHeadList" element={<SalarySlipHeadList/>} />
        <Route path="/PaySlipGenerateEmployeeList" element={<PaySlipGenerateEmployeeList/>} />
        <Route path="/GeneratePaySlip" element={<GeneratePaySlip/>} />
        <Route path="/PaySlipHistory" element={<PaySlipHistory/>} />
        <Route path="/ReminderPage" element={<ReminderPage/>} />
        <Route path="/ShiftManagement" element={<ShiftManagement/>} />
        <Route path="/EmployeeLeaveDetails" element={<EmployeeLeaveDetails/>} />
        <Route path="/EmployeeAttendance" element={<EmployeeAttendance/>} />
        <Route path="/LeaveHistory" element={<LeaveHistory/>} />
        <Route path="/EmployeeAttendanceHistory" element={<EmployeeAttendanceHistory/>} />
        <Route path="/AttendanceRegisterHistory" element={<AttendanceRegisterHistory/>} />
        <Route path="/DutyRoasterHistory" element={<DutyRoasterHistory/>} />
        <Route path="/EmployeePayslipView" element={<EmployeePayslipView/>} />
        <Route path="/AttendanceSignIn" element={<AttendanceSignIn/>} />
        <Route path="/OtRateMaster" element={<OtRateMaster/>} />
        <Route path="/OTRateList" element={<OTRateList/>} />
        <Route path="/GenerateAllEmployeePayslip" element={<GenerateAllEmployeePayslip/>} />
        <Route path="/QualificationMaster" element={<QualificationMaster/>} />
        <Route path="/QualificationList" element={<QualificationList/>} />
        <Route path="/EmployeeShiftTime" element={<EmployeeShiftTime/>} />
        <Route path="/DepartmrentHead" element={<DepartmrentHead/>} />
        <Route path="/ActivityHistory" element={<ActivityHistory/>} />
      </Route>

     </Routes>
        <Toaster
          reverseOrder={false}
          toastOptions={{
            style: { fontWeight: 600 },
            success: {
              icon: "✅",
              style: { background: "#d1fae5", color: "#065f46" }, // green background
            },
            error: {
              icon: "❌",
              style: { background: "#fee2e2", color: "#991b1b" }, // red background
            },
          }}
        />
</>
  );
}
